import { useTranslation } from 'react-i18next';
import { Mail, MessageCircle, Headphones } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  const links = [
    { label: t('footer.links.courses'), href: '#courses' },
    { label: t('footer.links.about'), href: '#about' },
    { label: t('footer.links.faq'), href: '#faq' },
  ];

  return (
    <footer id="footer" className="relative bg-crypto-darker border-t border-crypto-red/10">
      {/* Top gradient line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-crypto-red to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-crypto-red to-crypto-gradient-end flex items-center justify-center">
                <span className="text-white font-bold text-2xl">R</span>
              </div>
              <div>
                <span className="text-2xl font-bold text-white">RedLevel</span>
                <span className="text-crypto-red font-bold text-2xl">Crypto</span>
              </div>
            </div>
            <p className="text-gray-400 max-w-md mb-6">
              {t('footer.description')}
            </p>
            
            {/* Contact info */}
            <div className="space-y-3">
              <a href="mailto:support@redlevelcrypto.com" className="flex items-center gap-3 text-gray-400 hover:text-crypto-red transition-colors">
                <Mail className="w-5 h-5" />
                <span>{t('footer.contact.email')}</span>
              </a>
              <a href="https://t.me/redlevelcrypto" className="flex items-center gap-3 text-gray-400 hover:text-crypto-red transition-colors">
                <MessageCircle className="w-5 h-5" />
                <span>{t('footer.contact.telegram')}</span>
              </a>
              <div className="flex items-center gap-3 text-crypto-success">
                <Headphones className="w-5 h-5" />
                <span>{t('footer.contact.support')}</span>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-semibold mb-6">{t('nav.home')}</h4>
            <ul className="space-y-3">
              {links.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-crypto-red transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">{t('nav.contact')}</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://t.me/RedLevelCrypto"
                  className="text-gray-400 hover:text-crypto-red transition-colors"
                >
                  Telegram
                </a>
              </li>
              <li>
                <a
                  href="mailto:redlevelsupport@icloud.com"
                  className="text-gray-400 hover:text-crypto-red transition-colors"
                >
                  Email
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-crypto-red/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              {t('footer.rights')}
            </p>
            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <span>Made with</span>
              <span className="text-crypto-red">♥</span>
              <span>for crypto traders</span>
            </div>
          </div>
          <div className="mt-6 text-gray-500 text-xs text-center md:text-left leading-relaxed space-y-1 max-w-3xl mx-auto md:mx-0">
            <p>{t('footer.operator.name')}</p>
            <p>{t('footer.operator.taxId')}</p>
            <p>{t('footer.operator.address')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
